import { format, parseISO } from 'date-fns'

export const formatDate = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return '-'
  }
  try {
    const date = parseISO(dateString)
    return format(date, 'PPpp')
  } catch {
    return dateString
  }
}

export const formatDateShort = (dateString: string | null | undefined): string => {
  if (!dateString) {
    return '-'
  }
  try {
    const date = parseISO(dateString)
    return format(date, 'PP')
  } catch {
    return dateString
  }
}
